import { DatePipe } from '@angular/common'
import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { NgArrayPipesModule } from 'ngx-pipes'

import type { AuthorDto } from '../../../../api/responses'
import { PersonLinkDirective } from '../../../../shared/directives/person-link.directive'
import { FormatAuthorNamePipe } from '../../../../shared/pipes/format-author-name.pipe'
import type { ArticleWithNullableRefs } from '../../../../types/types'

@Component({
  standalone: true,
  selector: 'dhp-article-meta-data',
  templateUrl: './article-meta-data.html',
  imports: [
    PersonLinkDirective,
    TranslatePipe,
    NgArrayPipesModule,
    FormatAuthorNamePipe,
    DatePipe,
  ],
})
export class ArticleMetaData {
  article = input.required<ArticleWithNullableRefs>()
  isSelectionAndEssence = input.required<boolean>()
  showEditionAndDate = input(true)

  // Helper method to get either authors or creators
  getAuthors(): AuthorDto[] | undefined {
    // Only return the array, no sorting here
    return this.article().users?.authors?.length
      ? this.article().users?.authors
      : this.article().users?.creators
  }
}
